import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { RDDarkService } from '../../dark.service';

@Component({
  selector: 'rd-radio-button-option',
  template: `<span class="radioButtonContainer {{color}}RadioButton {{display}}" [class.rdDark]="dark" (click)="changeCheck()">
    <span class="checkMark" [class.checked]="checked"></span>
    <ng-content></ng-content>
  </span>

`,
  styles: [`.radioButtonContainer{--main-color:#ba9e5a;--text-color:black;--background-color:#f1f1f1;cursor:pointer;padding:3px;position:relative;transition:all .3s ease-in-out;color:var(--text-color)}.radioButtonContainer:active{background-color:var(--background-color)}.radioButtonContainer:hover{color:var(--main-color)}.radioButtonContainer.line{display:block}.radioButtonContainer .checkMark{position:relative;width:21px;height:21px;background-color:#e3e3e3;display:inline-block;vertical-align:middle;margin:3px 6px 3px 0;border-radius:50%;box-sizing:border-box;transition:all .1s ease-in-out}.radioButtonContainer .checkMark:after{content:'';position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);width:12px;height:12px;border-radius:50%}.radioButtonContainer .checkMark.checked{border:2px solid var(--main-color)}.radioButtonContainer .checkMark.checked:after{background-color:var(--main-color)}.radioButtonContainer.blueRadioButton{--main-color:#5a5aba}.radioButtonContainer.greenRadioButton{--main-color:#72ba5a}.radioButtonContainer.blue-lightRadioButton{--main-color:#5aa2ba}.radioButtonContainer.redRadioButton{--main-color:#ba5a5a}.radioButtonContainer.purpleRadioButton{--main-color:#a25aba}.radioButtonContainer.orangeRadioButton{--main-color:#ba8a5a}.radioButtonContainer.rdDark{--text-color:white;--background-color:#07384c}`]
})
export class RDRadioButtonOptionComponent implements OnInit {

  @Input() value = '';

  @Output() checkedChange: EventEmitter<any> = new EventEmitter();

  public checked = false;
  public color = 'gold';
  public display = 'line';
  public dark = false;

  constructor(private darkService: RDDarkService) { }

  ngOnInit() {
    this.darkService.getDarkElement().subscribe(() => {
      this.dark = this.darkService.isDark();
    });
    this.dark = this.darkService.isDark();
  }

  changeCheck() {
    this.checked = !this.checked;
    this.checkedChange.emit(this.checked);
  }

}
